<script lang="ts">
  import { ProductLineEntity } from "@shared/services/event_tracking/entities";
  import { EventTracking } from "@shared/services/event_tracking/events";

  export let mobileMode: boolean;
  export let producerDescription: string;
  export let productLineId: number;

  const { trackClick } = EventTracking;
  const productLineEntity = new ProductLineEntity({ productLineId });

  let showDetails: boolean = false;

  const toggleDetails = () => {
    showDetails = !showDetails;

    const targetEvent = showDetails
      ? "show_more_on_producer_description"
      : "show_less_on_producer_description";
    trackClick(targetEvent, [productLineEntity]);
  };

  const handleEnter = (e: KeyboardEvent) => {
    if (e.code === "Enter") {
      toggleDetails();
    }
  };

  $: shouldShowMore = producerDescription?.length > 275;

  let classes: string;
  let fadeClasses: string;
  $: {
    if (!showDetails && shouldShowMore && !mobileMode) {
      classes = "fizz-surface fizz-stack-4 details-closed";
      fadeClasses = "details-fade";
    } else {
      classes = "fizz-surface fizz-stack-4 fizz-stack-16";
      fadeClasses = "details-hidden";
    }
  }
</script>

<style>
  .divider {
    height: 1px;
    border: none;
    background-color: #eaeaea;
  }
  .details-closed {
    overflow: hidden;
    position: relative;
    height: 130px;
  }
  .details-hidden {
    display: none;
  }

  .details-fade {
    position: absolute;
    bottom: 0px;
    display: block;
    width: 100%;
    height: 35%;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #ffffff 80%);
  }
</style>

{#if producerDescription}
  {#if mobileMode}
    <details
      class="fizz-accordion fizz-stack-16"
      id="producer-description-accordion"
      on:click={toggleDetails}
      on:keyup={handleEnter}
    >
      <summary><h2 class="fizz-heading-4">About the producer</h2></summary>
      <div class="fizz-inset-square-12">
        <p class="fizz-text-large" style="white-space: pre-wrap;">
          {producerDescription}
        </p>
      </div>
    </details>
  {:else}
    <hr class="divider fizz-stack-16" />
    <div class={classes}>
      <h2 class="fizz-heading-3 fizz-stack-12">About the producer</h2>
      <p class="fizz-text-large fizz-stack-16" style="white-space: pre-wrap;">
        {producerDescription}
      </p>
      {#if !showDetails}
        <div class={fadeClasses} />
      {/if}
    </div>
    {#if shouldShowMore}
      <a
        href={"#"}
        class="fizz-text-strong"
        style="cursor: pointer"
        on:click|preventDefault={toggleDetails}
      >
        {showDetails ? "SHOW LESS" : "SHOW MORE"}
      </a>
    {/if}
  {/if}
{/if}
